import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * Ficha Descritiva / Ficha de Avaliação e Relatório Descritivo — QUATRO rotas, uma por item do
 * menu novo.
 *
 * O sistema antigo tinha nove itens de menu para seis páginas: `FichaAvaliacao.aspx` aparecia duas
 * vezes (a segunda com `?OcultaObs=1`, rotulada "Relatório Objetivo Semear"), "Legendas",
 * "Disciplinas", "Questionário" e "Replicar Ficha para Outras Escolas" eram quatro telas, e a
 * árvore inteira vinha duplicada em "Ficha de Avaliação Multi".
 *
 * O menu foi refeito no `seg_menu` e hoje há um item por assunto:
 *
 * | Item do menu                | Permissão   | Rota                            |
 * |-----------------------------|-------------|---------------------------------|
 * | Cadastro da Ficha           | 300304810   | `fichadescritivacadastro`       |
 * | Lançamento da Ficha         | 300304820   | `fichadescritivapreenchimento`  |
 * | Relatório Descritivo        | 300304611   | `fichadescritivarelatorio`      |
 * | Relatório Descritivo Avulso | 300304612   | `fichadescritivarelatorioavulso`|
 *
 * O que saiu, e por quê:
 *
 * - **"Relatório Objetivo Semear"** era a MESMA tela do lançamento, só com o campo de Observações
 *   escondido e outro rótulo. Hoje o nome do documento é o parâmetro `NomeFichaAvaliativa` (58) por
 *   escola/ano, e esconder as observações é uma opção do modal de impressão — nenhum dos dois
 *   justifica um item de menu à parte.
 * - **"Legendas", "Questionário" e "Replicar Ficha"** eram três atalhos para abas da tela de
 *   Cadastro. Com um item só, a tela abre na aba de blocos e as outras estão a um clique.
 *
 * Os nomes das rotas foram preservados: o legado abre o sistema novo por `/proxylegado/<rota>`, e o
 * `Proxy.vue` faz `$router.push({ name: rota })` — é o NOME que está gravado no `seg_menu`. Trocar
 * o nome de uma rota quebra o item de menu correspondente.
 */
export default [
  {
    // Menu novo: Cadastro da Ficha (300304810). Reúne blocos/perguntas, legendas e a cópia para
    // outro ano — as quatro telas de cadastro do sistema antigo.
    description: 'Cadastro da Ficha Descritiva',
    path: '/academico/fichadescritiva/cadastro',
    name: 'fichadescritivacadastro',
    component: () => import('@/views/academico/fichadescritiva/cadastro/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.CADASTROFICHA_MENU_300304810],
    },
    goesToMenu: true,
  },
  {
    // Menu novo: Lançamento da Ficha (300304820). Legado: ../MenuAcademico/FichaAvaliacao.aspx.
    description: 'Lançamento da Ficha',
    path: '/academico/fichadescritiva/preenchimento',
    name: 'fichadescritivapreenchimento',
    component: () => import('@/views/academico/fichadescritiva/preenchimento/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.LANCAMENTOFICHA_MENU_300304820],
    },
    goesToMenu: true,
  },
  {
    // Menu novo: Relatório Descritivo (300304611). Legado: ../MenuAcademico/RelatorioDescritivo.aspx.
    description: 'Relatório Descritivo',
    path: '/academico/fichadescritiva/relatoriodescritivo',
    name: 'fichadescritivarelatorio',
    component: () => import('@/views/academico/fichadescritiva/descritivo/Index.vue'),
    props: { avulso: false },
    meta: {
      permissions: [eTipoPermissao.RELATORIODESCRITIVO_MENU_300304611],
    },
    goesToMenu: true,
  },
  {
    // Menu novo: Relatório Descritivo Avulso (300304612).
    // Legado: ../MenuAcademico/RelatorioDescritivoAvulso.aspx.
    description: 'Relatório Descritivo Avulso',
    path: '/academico/fichadescritiva/relatoriodescritivoavulso',
    name: 'fichadescritivarelatorioavulso',
    component: () => import('@/views/academico/fichadescritiva/descritivo/Index.vue'),
    // A mesma tela atende as duas variantes; a prop decide o modo, como no sistema antigo, em que
    // as duas páginas eram cópias uma da outra com o escopo diferente.
    props: { avulso: true },
    meta: {
      permissions: [eTipoPermissao.RELATORIODESCRITIVOAVULSO_MENU_300304612],
    },
    goesToMenu: true,
  },
];
